
export function clipAccessTypeLabel(accessType) {
	if (accessType === "free") return "رایگان";
	if (accessType === "subscription") return "اشتراک";
	if (accessType === "credit") return "اعتبار";
	return "—";
}

export function mergeClipDisplay(clip, watchPayload) {
	if (!clip && !watchPayload) return null;
	const merged = { ...(clip ?? {}), ...(watchPayload ?? {}) };
	if (clip?.expertise_ids?.length && !watchPayload?.expertise_ids?.length) {
		merged.expertise_ids = clip.expertise_ids;
	}
	if (clip?.expertises?.length && !watchPayload?.expertises?.length) {
		merged.expertises = clip.expertises;
	}
	if (clip?.instructors_detail?.length && !watchPayload?.instructors_detail?.length) {
		merged.instructors_detail = clip.instructors_detail;
	}
	return merged;
}
